// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1AjlI","inputDescription":"styles_inputDescription__kT4gL"};